import UpdateAcademicDetails from './UpdateAcademicDetails';

export default UpdateAcademicDetails;
